// 定義類
export const SELECTABLE_LANG = [
  { tagName: 'JP', name: '日本語' },
  { tagName: 'EN', name: '英語' },
  { tagName: 'FR', name: 'フランス語' },
];

export const DEFAULT_KANA_LANG = 'JP';
export const DEFAULT_ALPHABET_LANG = 'EN';
